<ng-container *ngIf="expandedView; else small">
  <mojo-candidate-card
    [disableNavigation]="true"
    [sideDrawerCandidatesList]="candidates$ | async"
    [candidate]="assigned.candidate"
    [jobId]="job.id"
    [showAvatarLabel]="true"
    [enableSelection]="isShortListed$ | async"
    [showQA]="true"
  >
    <aside>
      <ng-template-outlet *ngTemplateOutlet="asideContent"></ng-template-outlet>
    </aside>

    <card-header
      style="display: flex"
      *ngIf="(isMobileViewService.isMobileView$() | async) === false"
    >
      <ng-template-outlet *ngTemplateOutlet="candidateLabels">
      </ng-template-outlet>
    </card-header>

    <card-header-mobile
      style="display: flex"
      *ngIf="isMobileViewService.isMobileView$() | async"
    >
      <ng-template-outlet *ngTemplateOutlet="candidateLabels">
      </ng-template-outlet>
    </card-header-mobile>

    <ng-template-outlet
      card-footer
      *ngTemplateOutlet="cardFooter"
    ></ng-template-outlet>
  </mojo-candidate-card>
</ng-container>

<ng-template #asideContent>
  <div
    (click)="$event.stopPropagation()"
    class="buttons-in-single-row"
  >
    <mojo-dropdown-menu-with-reject
      class="small-reject visible-on-hover"
      [candidateId]="assigned.candidate.id"
      [jobId]="job.id"
      [upperMenu]="jobMenuItems"
      [lowerMenu]="commonMenuItems"
      menu
    ></mojo-dropdown-menu-with-reject>
  </div>

</ng-template>

<ng-template #candidateLabels>
  <mojo-association-label
    [candidateId]="assigned.candidate.id"
    [jobId]="job.id"
    [internal]="assigned.candidate.internal"
  ></mojo-association-label>
  <mojo-hiring-manager-status
    *ngIf="hiringManagerFlow"
    [candidateId]="assigned.candidate.id"
    [jobId]="job.id"
  ></mojo-hiring-manager-status>
  <ng-container *mojoHasFeatureExtension="referralExtended">
    <mojo-referral-badge
      *ngIf="assigned.candidate.referredId"
      [candidateId]="assigned.candidate.id"
    >
    </mojo-referral-badge>
  </ng-container>
</ng-template>

<ng-template #cardFooter>
  <div
    (click)="$event.stopPropagation()"
    class="mt-3 d-block d-xs-none"
  >
    <mojo-dynamic-progress
      *ngIf="!!(assigned.association)  && !prospectTab"
      [association]="assigned.association"
      [isDirectApplicant]="isShortListed$ | async"
    ></mojo-dynamic-progress>
  </div>
</ng-template>

<ng-template #small>
  <mojo-candidate-label
    [candidate]="assigned.candidate"
    class="mb-1 padding-0"
  >
    <mojo-dropdown-menu-with-reject
      class="small-reject visible-on-hover"
      [candidateId]="assigned.candidate.id"
      [jobId]="job.id"
      [upperMenu]="jobMenuItems"
      [lowerMenu]="commonMenuItems"
      menu
    ></mojo-dropdown-menu-with-reject>
    <div
      progress
      (click)="$event.stopPropagation()"
      class="d-block d-xs-none"
    >
      <ng-container>
        <mojo-dynamic-progress
          *ngIf="!!(assigned.association) && !prospectTab"
          [association]="assigned.association"
          [expandedView]="hover$ | async"
          [isDirectApplicant]="isShortListed$ | async"
          [widget]="true"
          progress
        >
        </mojo-dynamic-progress>
      </ng-container>
    </div>
  </mojo-candidate-label>
</ng-template>
